import { render } from "./ourGoalSection.vue?vue&type=template&id=d291e26a"
import script from "./ourGoalSection.vue?vue&type=script&lang=js"
export * from "./ourGoalSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__